export default __webpack_public_path__ + "static/media/question_mark.c87369bc.svg";